import { useMemo } from "react";
import { useSessionStore as useStore } from "~/client/stores/session";

export default function useSessionDefaultChainId() {
  const [chainId, api] = useStore((state) => [state.defaultChainId, state.api]);

  return useMemo(
    () => ({
      chainId,
      setChainId: api.setDefaultChainId,
    }),
    [api, chainId],
  );
}
